import React from 'react';
import { COLORS, ACTIVITY_CONFIG, apexFontFamily } from './shared/chartTokens';
import './ActivitySummaryCard.css';

// ─────────────────────────────────────────────────────────────
// ActivitySummaryCard – Monthly activity summary
// Props:
//   activities: [{ type, count, label, timeframe }]
//     type: 'completed' | 'progress'
// ─────────────────────────────────────────────────────────────

const SingleActivityCard = ({ type, count, label, timeframe }) => {
  const cfg = ACTIVITY_CONFIG[type] || ACTIVITY_CONFIG.progress;

  return (
    <div className="activity-card">
      {/* Left accent stripe */}
      <div className="activity-card-accent" style={{ background: cfg.gradient }} />

      {/* Icon bubble */}
      <div className="activity-icon-bubble" style={{
        background: `${cfg.color}15`,
        border: `1.5px solid ${cfg.color}30`,
      }}>
        {cfg.icon}
      </div>

      {/* Text */}
      <div>
        <div className="activity-count" style={{ color: cfg.color }}>
          {typeof count === 'number' ? count.toLocaleString() : count}
        </div>
        <div className="activity-label" style={{ color: COLORS.text }}>{label}</div>
        <div className="activity-timeframe">{timeframe}</div>
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────
// ActivitySummaryCard – Container with section title
// ─────────────────────────────────────────────────────────────
const ActivitySummaryCard = ({ activities = [] }) => {
  if (!activities?.length) return null;

  return (
    <>
      {/* Section heading */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px',
        fontFamily: apexFontFamily,
      }}>
        <div style={{
          width: '4px', height: '22px', borderRadius: '3px',
          background: 'linear-gradient(180deg, #3f88a5 0%, #2e6b7a 100%)',
        }} />
        <h2 style={{
          margin: 0, fontSize: '16px', fontWeight: '700', color: COLORS.text,
          fontFamily: apexFontFamily,
        }}>
          Monthly Activity Summary
        </h2>
      </div>

      {/* Cards row */}
      <div style={{
        display: 'flex',
        gap: '14px',
        flexWrap: 'wrap',
        marginBottom: '28px',
      }}>
        {activities.map((activity, i) => (
          <SingleActivityCard key={i} {...activity} />
        ))}
      </div>
    </>
  );
};

export default ActivitySummaryCard;
